<!--
 饼图
-->
<template>
  <div :id="id" :style="echartsStyle"></div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  name: 'ECharPieChart',
  props: {
    id: {
      type: String
    },
    echartsStyle: {}
  },
  data () {
    return {
      myChart: null
    }
  },
  mounted () {
    this.drawLine()
    window.addEventListener('resize', () => this.resize())
  },
  methods: {
    // 自适应宽度
    resize () {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    refreshData (seriesData, title, legend) {
      this.myChart.hideLoading()
      var option = this.myChart.getOption()
      Object.assign(option.series[0], seriesData)
      option.title[0].text = title
      if (legend) {
        Object.assign(option.legend[0], legend)
      }
      this.myChart.setOption(option)
      this.myChart.resize()
    },
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      this.myChart.setOption({
        //表题
        title: {
          show: false  // 隐藏标题，避免和label重叠
        },
        // 小图标
        legend: {
          bottom: '3%',
          left: 'center',
          itemGap: 15,
          padding: [10, 0, 0, 0],
          textStyle: {
            fontSize: 12,
            color: '#fff'
          }
        },
        // 饼图标签
        label: {
          alignTo: 'edge',
          formatter: '{b} : {c}人 ({d}%)',
          minMargin: 5,
          edgeDistance: 10,
          lineHeight: 15,
          color: '#fff'  // 设置标签颜色为白色
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}人 ({d}%)'
        },
        color: ['#d91414', '#59d31d', '#fac858', '#d91414', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
        series: [
          {
            type: 'pie',
            radius: ['25%', '60%'],
            center: ['50%', '45%'],
            avoidLabelOverlap: true, // 解决文字与文字重叠引导线重叠
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            //是否显示线
            labelLine: {
              show: true,
              lineStyle: {
                color: '#fff'  // 引导线颜色为白色
              }
            },
            data: []
          }
        ]
      })
      // this.myChart.showLoading()
    }
  }
}
</script>

<style lang="less" scoped>
div[id] {
  position: relative;
}
</style>
